package com.appcreator.blueprint.components.basic

import com.appcreator.blueprint.core.Component
import com.appcreator.blueprint.core.ComponentClass
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("ProgressIndicatorComponent")
@ComponentClass(
    group = "Basic",
    title = "Progress Indicator",
    availableFrom = "0.0.1"
)
data class ProgressIndicatorComponent(

    override val _nodeId: String?,
    override val _nodeLabel: String?,
    override val _nodeRelativeId: String?,

    @InputProperty(
        title = "Size",
        availableFrom = "0.0.1"
    )
    val size: Int?,

    @InputProperty(
        title = "Thickness",
        availableFrom = "0.0.1"
    )
    val lineThickness: Int?,


): Component